export enum Direction {
    UP = 1,
    DOWN = -1,
    MIN = -999,
    MAX = 999
}

export type FormatFn = (value: number | string, isTyping: boolean) => string | null;

export type ParseFn = (value: string) => number | undefined;
